import styled from 'styled-components';
import { AuthorName } from '../styles';

export const StyledAuthorName = styled(AuthorName)`
  align-self: center !important;
`;
export const ImgContainer = styled.div``;
